import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import {
  ProductListByIdsConfigService,
  ProductService,
  AuthService,
  ProductSortService,
  GungFlowService,
  Product
} from 'gung-standard';
import { TyloProductGridViewComponent } from '../components/tylo-product-grid-view/tylo-product-grid-view.component';

@Injectable({
  providedIn: 'root'
})
export class TyloProductListByIdsConfigService extends ProductListByIdsConfigService {
  

  getLayouts(): ListLayout<Product>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => TyloProductGridViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductGrid'
      }
    ];
  }
}
